import type { EdgeTypes } from '@xyflow/react';
import { UkropEdge } from './UkropEdge';

export const edgeTypes = {
  ukrop: UkropEdge,
} satisfies EdgeTypes;
